import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0ad64b4f&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=0ad64b4f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad64b4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad64b4f')) {
      api.createRecord('0ad64b4f', component.options)
    } else {
      api.reload('0ad64b4f', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=0ad64b4f&scoped=true", function () {
      api.rerender('0ad64b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/index/home.vue"
export default component.exports